import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  BalanceteDespesaFuncaoService, BalanceteDespesaGrupoService,
  BalanceteDespesaProcessadaService, BalanceteDespesaRecursoService, BalanceteDespesaService,
  BalanceteExtraService, BalanceteReceitaService
} from 'administrativo-lib';
import { Exercicio, ExercicioService, FuncaoService, GlobalService, LoginPublico, OrgaoService } from 'eddydata-lib';
import { MessageService, SelectItem } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-transparencia-execucao-balancete',
  templateUrl: './transparencia-execucao-balancete.component.html'
})
export class TransparenciaExecucaoBalanceteComponent implements OnInit, OnDestroy {
  login: LoginPublico = new LoginPublico();
  mes: number;
  ano: number;
  listaOrgaos: SelectItem[];
  orgaos: number[] = [];
  public listaExercicios: Array<any>;
  public balanceteSelect = 'BR';
  public listaBalancetes: Array<any>;
  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    private messageService: MessageService,
    protected br: BalanceteReceitaService,
    protected bdp: BalanceteDespesaService,
    protected bdg: BalanceteDespesaGrupoService,
    protected bdf: BalanceteDespesaRecursoService,
    protected bdsf: BalanceteDespesaFuncaoService,
    protected bde: BalanceteExtraService,
    protected bp: BalanceteDespesaProcessadaService,
    protected exercicioService: ExercicioService,
    protected orgaoService: OrgaoService,
    protected funcaoService: FuncaoService) {
    this.login = GlobalService.obterSessaoLogin();
    this.mes = 1;
    this.ano = this.login.exercicio.id;
    this.orgaos.push(this.login.orgao.id);
  }

  ngOnInit() {
    this.login.contraste = sessionStorage.getItem('contraste') === 'true';
    this.orgaoService.obterTodos()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        this.listaOrgaos = [];
        for (const model of dados) {
          this.listaOrgaos.push({ label: `${model.codigo} - ${model.nome}`, value: model.id });
        }
      });
    this.exercicioService.obterTodosOrdenadoPorAno(this.login.cidade.id).pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        this.listaExercicios = new Array();
        const lista = dados.content;
        for (const exercicio of lista as Array<Exercicio>) {
          this.listaExercicios.push({ id: exercicio.id, ano: exercicio.ano });
        }
      });
    this.listaBalancetes = [
      { id: 'BR', nome: 'BALANCETE DA RECEITA ORÇAMENTÁRIA' },
      { id: 'BD', nome: 'BALANCETE DA DESPESA EMPENHADA' },
      { id: 'BG', nome: 'BALANCETE DE DESPESA POR GRUPO DE DESPESA' },
      { id: 'BF', nome: 'BALANCETE DE DESPESA POR FONTE DE RECURSO' },
      { id: 'BSF', nome: 'BALANCETE DE DESPESA POR FUNÇÃO DE GOVERNO' },
      { id: 'BE', nome: 'BALANCETE DE DESPESA EXTRA-ORÇAMENTÁRIA' },
      { id: 'BP', nome: 'BALANCETE DE DESPESA PROCESSADA' },
    ];
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  imprimir() {
    if (this.orgaos && this.orgaos.length > 0) {
      if (this.balanceteSelect === 'BD') {
        this.bdp.montarBalanceteDespesa(this.mes, this.ano, this.orgaos, this.login);
      } else if (this.balanceteSelect === 'BR') {
        this.br.montarBalanceteReceita(this.mes, this.ano, this.orgaos, this.login);
      } else if (this.balanceteSelect === 'BG') {
        this.bdg.montarBalanceteDespesa(this.mes, this.ano, this.orgaos, this.login);
      } else if (this.balanceteSelect === 'BF') {
        this.bdf.montarBalanceteDespesa(this.mes, this.ano, this.orgaos, this.login);
      } else if (this.balanceteSelect === 'BSF') {
        this.bdsf.montarBalanceteDespesa(this.mes, this.ano, this.orgaos, this.login);
      } else if (this.balanceteSelect === 'BE') {
        this.bde.montarBalanceteExtra(this.mes, this.ano, this.orgaos, this.login);
      } else if (this.balanceteSelect === 'BP') {
        this.bp.montarBalancete(this.mes, this.ano, this.orgaos, this.login);
      } else {
        this.messageService.add({ severity: 'warn', summary: 'Validação', detail: 'Selecione o anexo a ser impresso' });
      }
    } else {
      this.messageService.add({ severity: 'warn', summary: 'Validação', detail: 'Selecione o(s) órgão(s) a serem impressos' });
    }
  }
}
